import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styled from "styled-components";
import { Box, Button, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { AddCircle, Checklist, Edit, ListAlt, RemoveRedEye, Search } from '@mui/icons-material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useNavigate } from 'react-router-dom';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { useEffect, useState } from 'react';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { AccountTypes } from './CustomerConstants';
import ThreeDotMenu from '../../components/menu/Menu';
import { ActivateDeactivateAlertModal } from '../../components/modal/ActivateDeactivateAlertModal';
import { TablePagination } from '../../components/pagination/Pagination';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { useForm } from "react-hook-form";
import { LoadingButton } from '@mui/lab';
import React from 'react';
import { AppContext } from '../../contexts/AppContext';
import SingleInputDateRangePicker from '../../components/dateRange/DateRange';
import Close from '@mui/icons-material/Close';

export const TableCellHeading = styled(TableCell)`
    font-weight: 700 !important;
    min-width:${(props: any): string => props.minwidth ? props.minwidth : '60px'};
    padding:
`;

export default function CustomerListTable() {

    const [customers, setCustomers] = useState<any | null>();
    const [count, setCount] = useState<any>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showApproved, setShowApproved] = useState<string>('true');
    const [showRejected, setShowRejected] = useState<string>('false');

    const [selectedId, setSelectedID] = useState<any | null>();
    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(10)
    const initialValues = { mobileNo: "", accountNo: "", name: "", lockerNo: "", isMainTable: showApproved, toDate: '', fromDate: '' }

    const { handleSubmit, control, formState: { errors, }, setValue, getValues } = useForm({
        defaultValues: initialValues
    })

    const navigate = useNavigate();


    const handleProceed = (param?: string) => {
        navigate({
            pathname: `new-registration`,
        })
    };

    const { get } = useCrudForm();
    const { user } = React.useContext(AppContext);

    const fetchData = ({ toDate, fromDate, name, mobileNo, lockerNo, accountNo, isMainTable, isReject }: { fromDate?: string, toDate?: string, name?: string, accountNo?: string, lockerNo?: string, mobileNo?: string, isMainTable?: string, isReject?: boolean }) => {
        setLoading(true)
        get({
            endpoints: endpoints.customer.list({ skip: skip * take, take, name, accountNo, lockerNo, mobileNo, isMainTable, fromDate, toDate, isReject }),
            onSuccess: (data: any) => {
                setCustomers(data.data.list)
                setCount(data.data.count)
                setButtonLoading(false)
                setLoading(false)
            },
            onError: (error: any) => {
                setCustomers([])
                setLoading(false)
                setButtonLoading(false)
            }
        })
    }

    const handleSearchButtonClick = (values: any) => {
        setSkip(0)
        setTake(take)
        setButtonLoading(true)
        fetchData({ fromDate: values?.fromDate, toDate: values?.toDate, name: values?.name, accountNo: values?.accountNo, lockerNo: values?.lockerNo, mobileNo: values?.mobileNo, isMainTable: showApproved })
    };

    const resetSearch = () => {
        setValue("name", '');
        setValue("accountNo", '');
        setValue("lockerNo", '');
        setValue("mobileNo", '');
        setValue("toDate", '');
        setValue("fromDate", '');
        setValue("isMainTable", 'true');
        setLoading(true)
        fetchData({ isMainTable: showApproved })
    };
    const lockerList = (lockers: any) => lockers.map((locker: any, index: number) => <Typography key={index} style={{ fontSize: "12px" }}>{locker.lockerNumber}</Typography>)

    const onSuccess = () => {
        fetchData({ isMainTable: 'true' });
        setOpenAlertModal(false)
        setSelectedID(null)
    }

    const onError = () => {
        setOpenAlertModal(false)
        setSelectedID(null)
    }

    useEffect(() => {
        fetchData({
            name: getValues()?.name,
            accountNo: getValues()?.accountNo,
            lockerNo: getValues()?.lockerNo,
            mobileNo: getValues()?.mobileNo,
            fromDate: getValues()?.fromDate,
            toDate: getValues()?.toDate,
            isMainTable: showApproved,
            isReject: showRejected === 'true' ? true : false
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, take])

    return (
        <>
            <Grid container spacing={1} style={{ marginBottom: "24px", display: 'flex', justifyContent: 'right' }}>
                <Grid item>
                    <Button onClick={() => {
                        setSkip(0)
                        setTake(10)
                        setShowApproved('true')
                        setShowRejected('false')
                        fetchData({ isMainTable: 'true' });
                    }} variant="contained" disabled={loading}
                        sx={{ padding: '4px 8px', backgroundColor: showApproved === 'true' ? '#07bc0c' : '#3150A1', marginLeft: '8px', '&:hover': { backgroundColor: showApproved === 'true' ? '#07bc0c' : null } }}>
                        <ListAlt />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Approved List</Typography>
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={() => {
                        setSkip(0)
                        setTake(10)
                        setShowApproved('false')
                        setShowRejected('false')
                        fetchData({ isMainTable: 'false' });
                    }} variant="contained" disabled={loading}
                        sx={{ padding: '4px 8px', backgroundColor: showApproved === 'false' && showRejected === 'false' ? '#07bc0c' : '#3150A1', marginLeft: '8px', '&:hover': { backgroundColor: showApproved === 'false' && showRejected === 'false' ? '#07bc0c' : null } }}>
                        <Checklist />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Need to Approve</Typography>
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={() => {
                        setSkip(0)
                        setTake(10)
                        setShowApproved('false')
                        setShowRejected('true')
                        fetchData({ isMainTable: 'false', isReject: true });
                    }} variant="contained" disabled={loading}
                        sx={{ padding: '4px 8px', backgroundColor: showRejected === 'true' ? '#FF0000' : '#3150A1', marginLeft: '8px', '&:hover': { backgroundColor: showRejected === 'true' ? '#FF0000' : null } }}>
                        <Close />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Rejected</Typography>
                    </Button>
                </Grid>
                {user?.role?.toLowerCase() !== 'checker' ? <Grid item>
                    <Button onClick={() => handleProceed()} variant="contained" disabled={loading} sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '8px', '&:hover': { backgroundColor: '#3150A1', } }}>
                        <AddCircle />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>New Customer</Typography>
                    </Button>
                </Grid> : null}
                <Grid item>
                    <Button onClick={() => setShowFilter(!showFilter)} variant="contained" disabled={loading} sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '8px', '&:hover': { backgroundColor: '#3150A1', } }}>
                        <FilterAltIcon />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Filter</Typography>
                    </Button>
                </Grid>
            </Grid>
            {
                showFilter ? <>
                    <Typography sx={{ color: 'gray', fontSize: '13px', marginBottom: '12px' }}>Search Customer</Typography>
                    <form>
                        <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'start', marginBottom: "24px" }}>
                            <Grid item  >
                                <ControlledInput width={"130px"} name="mobileNo" control={control} errors={errors} label="Mobile" size={'small'} />
                            </Grid>
                            <Grid item >
                                <ControlledInput width={'180px'} name="accountNo" control={control} errors={errors} label="Account number" size={'small'} />
                            </Grid>
                            <Grid item >
                                <ControlledInput width={'160px'} name="name" control={control} errors={errors} label="Name" size={'small'} />
                            </Grid>
                            <Grid item >
                                <ControlledInput width={'110px'} name="lockerNo" control={control} errors={errors} label="Locker" size={'small'} />
                            </Grid>

                            <SingleInputDateRangePicker control={control} errors={errors} setValue={setValue} getValues={getValues} />
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'right' }}>
                                <LoadingButton loading={buttonLoading} onClick={() => resetSearch()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} >Reset</LoadingButton>
                                <LoadingButton type='submit' loading={buttonLoading} onClick={(e) => { e.preventDefault(); handleSubmit(handleSearchButtonClick)() }} variant="contained" sx={{ marginLeft: '16px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} ><Search /></LoadingButton>
                            </Grid>
                        </Grid>
                    </form>
                </> : null
            }
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 460 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableHeadCell minwidth='40px'>S.N</TableHeadCell>
                                <TableHeadCell align="left" minwidth='130px'>
                                    Account Type
                                </TableHeadCell>
                                <TableHeadCell align="left" minwidth='150px'>
                                    Account No.
                                </TableHeadCell>
                                <TableHeadCell align="left" minwidth='160px'>
                                    FullName
                                </TableHeadCell>
                                <TableHeadCell align="left" minwidth='100px'>
                                    Mobile
                                </TableHeadCell>
                                <TableHeadCell align="left" minwidth='150px'>
                                    Address
                                </TableHeadCell>
                                <TableHeadCell align="left" minwidth='80px'>
                                    Lockers
                                </TableHeadCell>
                                <TableHeadCell align="center" minwidth='125px'>
                                    Fingerprint ?
                                </TableHeadCell>
                                <TableHeadCell align="center" minwidth='100px'>
                                    Action
                                </TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!customers || loading ? <TableRowsLoader rowsNum={5} colNum={9} />
                                : customers && customers?.length <= 0 ? <TableRow>
                                    <TableCell colSpan={10} align='center'>No Data Found</TableCell>
                                </TableRow> : customers?.map((row: any, index: number) => (
                                    <Tooltip sx={{ backgroundColor: '#121212' }} title={
                                        <Box>
                                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                                                </Box>
                                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By: {row?.createdUsername ?? "N/A"}</Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                                                </Box>
                                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By: {row?.updatedUsername ?? "N/A"}</Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                                                </Box>
                                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By: {row?.verifiedUsername ?? "N/A"}</Typography>
                                            </Box>
                                        </Box>
                                    } placement="bottom" arrow key={index}>
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, ":hover": { backgroundColor: '#E3E3E3' } }}
                                        >
                                            <TableCell style={{ fontSize: "12px" }}>
                                                {skip > 0 ? skip * take + index + 1 : index + 1}
                                            </TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{AccountTypes[row.accountType]}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.accountNumber}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{`${row?.firstName}  ${row?.middleName ?? ""}  ${row?.lastName}`}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.mobileNumber}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row.temporaryAddress}</TableCell>
                                            <TableCell align="left" style={{ fontSize: "12px" }}>{row?.customerLockers?.length > 0 ? lockerList(row?.customerLockers) : "N/A"}</TableCell>
                                            <TableCell align="center" style={{ fontSize: "12px" }}>{row?.isBiometricTaken ? 'YES' : 'NO'}</TableCell>
                                            <TableCell align="left">
                                                <Box sx={{ display: "flex", gap: "5px", justifyContent: 'start', align: 'center' }}>
                                                    {
                                                        user?.role?.toLowerCase() !== 'checker' && showApproved === 'true' ? <Tooltip title="Edit customer" >
                                                            <IconButton onClick={() => navigate(`new-registration/${row.id}?isMainTable=${row.isMainTable}`)} sx={{ width: '30px', height: '30px' }}>
                                                                <Edit sx={{ width: '30px', height: '30px', backgroundColor: '#32CD33', borderRadius: '100%', padding: '6px', color: 'white' }} />
                                                            </IconButton>
                                                        </Tooltip> : null
                                                    }
                                                    <Tooltip title="View customer details">
                                                        <IconButton onClick={() => navigate(`/customers/${row.id}?isMainTable=${row.isMainTable}`)} sx={{ width: '30px', height: '30px' }}>
                                                            <RemoveRedEye sx={{ width: '30px', height: '30px', backgroundColor: '#3150A1', borderRadius: '100%', padding: '6px', color: 'white' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    {
                                                        user?.role?.toLowerCase() !== 'checker' && showApproved === 'true' && row?.accountType !== 2 ? <ThreeDotMenu id={row.id} accountNumber={row.accountNumber} accountType={row.accountType} fetchData={fetchData} isActive={row.isActive} isMainTable={'true'} /> : null
                                                    }
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    </Tooltip>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {customers && (customers?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
            </Paper>
            <ActivateDeactivateAlertModal
                customEndpoint={true}
                onSuccess={onSuccess}
                onError={onError}
                endpoint={endpoints.customer.activate + selectedId}
                selectedId={selectedId}
                openAlertModal={openAlertModal}
                setOpenAlertModal={setOpenAlertModal}
                message={`Are you sure want to ${customers?.find((customer: any) => customer.id === selectedId)?.isActive ? 'deactivate' : 'activate'}?`}
            />
        </>
    );
}
